<template lang="pug"></template>

<script>
export default {
    name: 'BotaoCompartilhamentoDados',
    componentOptions: {
        title: 'CompartilhamentoDados',
        actions: [
            [
                {
                    name: 'Compartilhamento de Dados',
                    iconClass: 'lyra-icon lyra-file-share-line',
                    showView: false,
                    action: 'abrirCompartilhamentoDados',
                    route: 'CompartilhamentoDados',
                    nameTranslationKey:
                        'mensagens.menuLateral.compartilhamentoDeDados'
                }
            ]
        ]
    },

    methods: {
        abrirCompartilhamentoDados() {
            if (this.$route.name !== 'CompartilhamentoDados') {
                this.$router.push({ name: 'CompartilhamentoDados' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
